import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { userNameValidator } from '../../validators/username-validator';
import { RegexList } from 'constants/regex';
import { IUserNameFormOutput } from '@app/auth/models/username-form-output-model';
import { AuthViewEnum } from '../../enums/auth-step-enum';
import { GoogleSigninButtonModule } from '@abacritt/angularx-social-login';
import { AuthSliderPresenterComponent } from "../auth-slider-presenter/auth-slider-presenter.component";
import { StandardNumberDirective } from '@shared/utils/standard-number.directive';
import { ButtonLoaderDirective } from '@shared/directive/button-loader/button-loader.directive';

@Component({
    selector: 'app-username-form-presenter',
    imports: [
        ReactiveFormsModule,
        GoogleSigninButtonModule,
        ButtonLoaderDirective,
        AuthSliderPresenterComponent,
        StandardNumberDirective
    ],
    templateUrl: './username-form-presenter.component.html',
    styleUrl: './username-form-presenter.component.scss'
})
export class UsernameFormPresenterComponent implements OnInit {

  @Input() getOtpLoading = false;
  // @Input() mode: string = 'register'
  @Output() onUserNameChanged: EventEmitter<IUserNameFormOutput> = new EventEmitter<IUserNameFormOutput>();
  @Output() onLoginWithPasswordDesired: EventEmitter<AuthViewEnum> = new EventEmitter<AuthViewEnum>();
  form!: FormGroup;
  fb: FormBuilder = inject(FormBuilder);

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.form = this.fb.group({
      userName: new FormControl(null, [Validators.required, userNameValidator()])
    });
  }


  submitUserName() {
    const userName = this.form.get('userName')?.value;
    const isEmail = RegexList.email.test(userName);
    const output: IUserNameFormOutput = {
      userName,
      type: isEmail ? 'email' : 'phone'
    }
    this.onUserNameChanged.emit(output);
  }

  loginWithPassword() {
    this.onLoginWithPasswordDesired.emit(AuthViewEnum.login);
  }


}
